"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingOverflow = exports.settingContent = void 0;
var _reactUi = require("@100mslive/react-ui");
var settingOverflow = (0, _reactUi.css)({
  flex: "1 1 0",
  pr: "$12",
  mr: "-$12",
  overflowY: "auto"
});
exports.settingOverflow = settingOverflow;
var settingContent = (0, _reactUi.css)({
  display: "flex",
  flexDirection: "column",
  "&[hidden]": {
    display: "none"
  }
});
exports.settingContent = settingContent;